import React, {  useState } from "react";
import { getFileHash } from "../utils/utils";
import axios from "axios";
import swal from "sweetalert";
import { Modalprogress } from "../components/Modal/Modalprogress";
import { Modalsuccessfile } from "../components/Modal/Modalsuccessfile";
const { REACT_APP_CORD_MIDDLEWARE, REACT_APP_CLIENT_TOKEN, REACT_APP_VERIFY_TOKEN } = process.env;

export const ApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    certification: "",
    gender: "",
    email: "",
    file: null,
  });
  const [successModal, setSuccessModal] = useState(false);
  const [identifier, setIdentifier] = useState();
  const [loading, setLoading] = useState(false);
  const [blockHash, setBlockHash] = useState("");
  const [currentHash, setCurrentHash] = useState("");
  const [verified, setVerified] = useState();
  // Handle text and select input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file input change
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const currentHash = await getFileHash(file);
    setCurrentHash(currentHash);
    setLoading(true);
    setTimeout(() => {
      verifyFile(currentHash);
    }, [6000]);

    setFormData((prev) => ({ ...prev, file }));
  };

  const verifyFile = async (hash) => {
    const response = await axios.post(
      `${REACT_APP_CORD_MIDDLEWARE}/verify/document/verify`,
      { filehash: hash },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${REACT_APP_VERIFY_TOKEN}`,
        },
        validateStatus: (status) => status < 500,
      }
    );

    if (response.status === 200) {
      setLoading(false);
      if (response.data?.data?.revoked) {
        swal({
          title: "Revoked",
          text: "Document is Revoked",
          icon: "error",
        });
      } else {
        setBlockHash(response.data?.data?.registryEntryId);
        setVerified(true);
        setSuccessModal(true);
      }
    } else if (response.status === 400) {
      setLoading(false);
      setVerified("error");
      swal({
        title: "Not anchored on chain",
        text: response.data.err || "An error occurred",
        icon: "error",
      });
    } else {
      setLoading(false);
      setVerified(false);
      swal({
        title: "Unable to process the request",
        text: response.data.error || "An unknown error occurred",
        icon: "error",
      });
    }
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const outputData = {
      ...formData,
      file: formData.file ? formData.file.name : null, // or send as base64 if needed
    };

    alert("Form submitted! ");
  };

  return (
    <div>
      <Modalprogress
        loading={loading}
        msg={[
          "Looking for digest on the chain...",
          `Verifying document on chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
        ]}
      />
      <Modalsuccessfile
        loading={successModal}
        msg={"Verification Successful"}
        txtmsg={
          "Document successfully verified on  weavenet.cord.network chain."
        }
        Identifier={identifier}
        blockhash={blockHash}
        fileHash={currentHash} //  line to pass the file hash
        onClose={() => {
          setSuccessModal(false);
        }}
      />

      <div className="container d-flex justify-content-center align-items-center mt-5 mb-6">
        <div className="col-md-5">
          <h2 className="mb-4 text-center">Application Form</h2>
          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            {/* Age */}
            <div className="mb-3">
              <label htmlFor="age" className="form-label">
                Age
              </label>
              <input
                type="number"
                className="form-control"
                id="age"
                name="age"
                value={formData.age}
                onChange={handleChange}
              />
            </div>

            {/* Gender */}
            <div className="mb-3">
              <label htmlFor="gender" className="form-label">
                Gender
              </label>
              <select
                className="form-select"
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Mail ID */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Mail ID
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="file" className="form-label">
                Upload Certificate
              </label>
              <div className="position-relative">
                <input
                  className={`form-control pe-5 ${
                    verified === true
                      ? "border-success"
                      : verified === "error"
                      ? "border-danger"
                      : ""
                  }`}
                  type="file"
                  id="file"
                  name="file"
                  onChange={handleFileChange}
                />
                {verified && (
                  <span
                    className={`position-absolute top-50 end-0 translate-middle-y me-3 fs-5 ${
                      verified === true ? "text-success" : "text-danger"
                    }`}
                    style={{ pointerEvents: "none" }}
                  >
                    {verified === true ? "✅" : "❌"}
                  </span>
                )}
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-5">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
